import { toast } from '../../../components/ui/toaster';
import { useWorkspaceStore } from '../../workspace/core/store/workspaceStore';
import type {
  SecurityManagerTabContent,
  SecurityManagerView,
  SecurityObjectType,
} from '../../workspace/core/types/workspaceTypes';
import { getConnectionContext } from './securityExplorerNodeContext';

export function openSecurityCreateFromExplorerFolder(options: {
  connectionId: string;
  view: SecurityManagerView;
  objectType: SecurityObjectType;
  database?: string;
}): void {
  const { connectionId, view, objectType, database } = options;

  const connectionContext = getConnectionContext(connectionId);
  if (!connectionContext) {
    toast.error({ title: 'Error', description: 'Connection not found' });
    return;
  }

  if (view === 'database' && !database) {
    toast.error({ title: 'Error', description: 'Database is required for this action' });
    return;
  }

  const { tabs, addTab, setActiveTab, updateTabContent, updateTabConnectionInfo, updateTabTitle } =
    useWorkspaceStore.getState();

  const content: Partial<SecurityManagerTabContent> = {
    view,
    objectType,
    selectedDatabase: view === 'database' ? database : undefined,
    selectedObjectId: undefined,
    isCreateMode: true,
  };

  const connectionLabel =
    connectionContext.connectionName === 'Unnamed Connection'
      ? connectionContext.serverHost
      : connectionContext.connectionName;

  const title = `Security Manager - ${connectionLabel}`;
  const connectionInfo = {
    connectionId,
    connectionName: connectionContext.connectionName,
    serverHost: connectionContext.serverHost,
    database: view === 'database' ? database : connectionContext.defaultDatabase,
  };

  const existingTab = tabs.find(
    (tab) => tab.type === 'security' && tab.connectionInfo?.connectionId === connectionId
  );

  if (existingTab) {
    updateTabContent(existingTab.id, content);
    updateTabConnectionInfo(existingTab.id, connectionInfo);
    if (existingTab.customTitle !== true) {
      updateTabTitle(existingTab.id, title);
    }
    setActiveTab(existingTab.id);
    return;
  }

  addTab({ type: 'security', title, connectionInfo, content });
}
